import Vue from '../../../helpers/VueBase';
import Header from './Header.vue';

import '../../../assets/styles/rin-global.less';
import '../../../assets/styles/rin-table.less';
import '../../../assets/styles/rin-settings.less';

Vue.config.productionTip = false;

new Vue({
  render: h => h(Header),
}).$mount('.header-mobile-vue');
